export const SET_KYC = "SET_KYC";
export const FETCH_KYC = "FETCH_KYC";
export const FETCH_ME = "FETCH_ME";
export const FETCH_OTHER = "FETCH_OTHER";
export const FETCH_2FA_STATUS_OF_USER = "FETCH_2FA_STATUS_OF_USER";
export const SET_2FA_STATUS_OF_USER = "SET_2FA_STATUS_OF_USER";
export const RESET_2FA_STATUS_OF_USER = "RESET_2FA_STATUS_OF_USER";